import axios from "axios";

export async function deleteTargetGroup(id) {
    try {
        const response = await axios.delete(`/targetGroups/delete/${id}`);
        return response.data;
    } catch (e) {
        const text = e.response?.data?.message || "Ошибка удаления группы";
        throw new Error(text);
    }
}
